function buildMultiplesMap() {
  const map = {};
  document.querySelectorAll('template.quickbuy-placeholder-template').forEach(function(tpl) {
    const div = tpl.content.querySelector('[data-product-id]');
    if (!div) return;
    const productId = div.dataset.productId;
    const multiple = parseInt(div.dataset.quantityMultiple) || 1;
    if (multiple > 1) map[productId] = multiple;
  });
  return map;
}

function updateButtonText(customSelect, text) {
  const btn = customSelect.button;
  if (!btn) return;
  const span = btn.querySelector('.text-start');
  if (span) { span.textContent = text; return; }
  btn.childNodes.forEach(function(node) {
    if (node.nodeType === 3) node.textContent = text;
  });
}

function patchCustomSelect(container, multiple) {
  const optionList = container.querySelector('.custom-select__listbox');
  if (!optionList) return;

  const existingOptions = optionList.querySelectorAll('.js-option');
  if (!existingOptions.length) return;

  existingOptions.forEach(function(opt, i) {
    const val = multiple * (i + 1);
    opt.setAttribute('data-value', val);
    const span = opt.querySelector('span');
    if (span) span.textContent = val;
    else opt.textContent = val;
    opt.removeAttribute('aria-selected');
  });

  existingOptions[0].setAttribute('aria-selected', 'true');
  const customSelect = optionList.closest('custom-select');
  if (customSelect) {
    customSelect.selectedOption = existingOptions[0];
    customSelect.selectOption(existingOptions[0]);
    updateButtonText(customSelect, multiple);

    // Aggiorna subito l'input con il primo valore
    const qtyInputInit = container.querySelector('input[name="quantity"]');
    if (qtyInputInit) {
      qtyInputInit.value = multiple;
      qtyInputInit.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Click listener — aggiorna input quantità
    existingOptions.forEach(function(opt) {
      opt.addEventListener('click', function() {
        customSelect.selectedOption = opt;
        customSelect.selectOption(opt);
        setTimeout(function() {
          updateButtonText(customSelect, opt.dataset.value);
          const qtyInput = container.querySelector('input[name="quantity"]');
          if (qtyInput) {
            qtyInput.value = opt.dataset.value;
            qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }, 200);
      });
    });
  }
}

// Quickbuy
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.js-quickbuy-button');
  if (!btn) return;

  const multiplesMap = buildMultiplesMap();

  const observer = new MutationObserver(function(mutations, obs) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        if (!node.classList.contains('js-qb-buy-buttons')) return;

        obs.disconnect();

        const container = document.querySelector('.quickbuy-form');
        if (!container) return;
        const productId = container.dataset.productId;
        const multiple = multiplesMap[productId] || 1;
        if (multiple <= 1) return;

        setTimeout(function() {
          patchCustomSelect(container, multiple);
        }, 100);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 5000);
});

// Scheda prodotto
document.addEventListener('DOMContentLoaded', function() {
  const multiple = window.quantityMultiple || 1;
  if (multiple <= 1) return;

  function tryPatch(attempts) {
    const cs = document.querySelector('custom-select#qty-proxy');
    if (!cs || !cs.button) {
      if (attempts > 0) setTimeout(() => tryPatch(attempts - 1), 200);
      return;
    }
    patchCustomSelect(cs.closest('[data-product-id]') || document, multiple);
  }

  setTimeout(() => tryPatch(10), 300);
});
